import { observable, action } from 'mobx';

export interface IConfig {
    voiceSearch: {
        enabled: boolean;
        google: {
            apiKey: string;
            languageCode: string;
        };
    };
}

export class Config {
    @observable public config: IConfig;

    @action
    public updateConfig(config: Partial<IConfig>) {
        this.config = { ...this.config, ...config };
    }
}
